<template>
  <PageWrap
    :heading="$t('admin.nav.links.vat_rates')"
    useForm
    @submit="submitForm"
    :loading="loading"
  >
    <div :class="$style.base">
      <VatRate
        v-for="vatRate in vatRates"
        :key="vatRate._uid"
        :vatRate="vatRate"
        @update="onUpdate(vatRate, $event)"
        @delete="onDelete(vatRate)"
        @setDefault="onSetDefault(vatRate)"
        v-test="'vat-rate'"
      />
      <BaseText
        @click="addVatRate"
        v-test="'vat-rates-add'"
      >
        + {{ $t('vat_rates.add_vat_rate') }}
      </BaseText>
    </div>
    <template #actions>
      <BaseButton
        :loading="saving"
        submitForm
        v-test="'vat-rates-save'"
        :fullWidth="$screen === 's'"
      >
        {{ $t('global.actions.save') }}
      </BaseButton>
    </template>
  </PageWrap>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia';
import { modal } from '@/helpers/ui';
import PageWrap from '@/modules/admin/PageWrap.vue';
import { useVatRatesStore } from '@/stores/vat-rates';
import VatRate from './VatRate.vue';

let _uid = 0;

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'VatRates',
  components: {
    VatRate,
    PageWrap,
  },
  data() {
    return {
      vatRates: [],
    };
  },
  watch: {
    vatRatesData: {
      handler(value) {
        this.vatRates = [...value]
          .sort((a, b) => b.percentage - a.percentage)
          .map((rate) => {
            _uid++;
            return {
              ...rate,
              _uid,
            };
          });
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState(useVatRatesStore, {
      vatRatesData: 'vatRates',
      loading: 'loading',
      saving: 'saving',
    }),
  },
  methods: {
    ...mapActions(useVatRatesStore, ['deleteVatRate', 'updateVatRates']),
    addVatRate() {
      _uid++;

      this.vatRates.push({
        _uid,
        name: '',
        percentage: 0,
        default: false,
      });
    },
    onDelete(vatRate) {
      modal('confirmation', {
        item: vatRate.name ? vatRate.name : null,
        type: 'delete',
      }).then(() => {
        if (vatRate.id) {
          this.deleteVatRate(vatRate.id);
        } else {
          this.vatRates = this.vatRates.filter(
            (rate) => rate._uid !== vatRate._uid,
          );
        }
      });
    },
    onUpdate(vatRate, props) {
      const rate = this.vatRates.find((rate) => rate._uid === vatRate._uid);
      rate[props.key] = props.value;

      if (props.key === 'default' && props.value) {
        const otherRates = this.vatRates.filter(
          (rate) => rate._uid !== vatRate._uid,
        );
        otherRates.forEach((rate) => {
          rate.default = false;
        });
      }
    },
    submitForm() {
      this.updateVatRates(
        this.vatRates.map((rate) => ({
          id: rate.id || null,
          name: rate.name,
          default: rate.default,
          percentage: rate.percentage,
        })),
      );
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  gap: $spacing;
}

.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: $spacing;
}
</style>
